import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import css from './index.styl?inline';
import template from './index.jade';

export default registerMPElement(`mp-switch`, class extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'disabled': `boolean`,
      'on': `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        on: false,
        disabled: false,
      },
      helpers: {
        toggleSwitch: () => {
          this.dispatchEvent(new CustomEvent(`change`, {detail: {on: !this.state.on}}));
        },
      },
    };
  }

  attributeChangedCallback(attr) {
    super.attributeChangedCallback(...arguments);
    if (attr === `on`) {
      this.update({on: this.attrs[`on`]});
    } else if (attr === `disabled`) {
      this.update({disabled: this.attrs[`disabled`]});
    }
  }
});



// WEBPACK FOOTER //
// ../iron/common/components/switch/index.js